/**
 * Formats a number as a currency string with an optional currency sign.
 * 
 * @param {number} value - The number to format as currency.
 * @param {string} [currencySign] - The currency sign to append to the formatted value.
 * @returns {string} The formatted currency string.
 */
const currencyFormat = (value, currencySign) => {
  let result
  if (
    typeof value !== "number" ||
    typeof value.toLocaleString !== "function"
  ) {
    result = value || 0
  } else {
    result = value.toLocaleString("uk", { maximumFractionDigits: 0 })
  }
  return currencySign ? `${result}\u00A0${currencySign}` : result
}

const currencyFormatWithSign = (value, sign = "₴") => currencyFormat(value, sign)

export default currencyFormat
export { currencyFormatWithSign }